import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosAdmin } from '../../../utils/axiosUser';

export const initStateCountryCreate = {
  countryCreate: { data: null, loading: false, error: null },
};

export const countryCreate = createAsyncThunk('user/countryCreate', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosAdmin
    .post(`/country/create`, data)
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerCountryCreate = {
  [countryCreate.pending]: (state) => {
    state.countryCreate.loading = true;
  },
  [countryCreate.fulfilled]: (state, action) => {
    state.countryCreate.loading = false;
    state.countryCreate.data = action.payload;
    state.countryCreate.error = null;
  },
  [countryCreate.rejected]: (state, action) => {
    state.countryCreate.data = null;
    state.countryCreate.loading = false;
    state.countryCreate.error = action.payload;
  },
};
